























import { Component } from 'vue-property-decorator'
import { Chart } from 'highcharts-vue'
import * as ColorUtils from '@/components/Survey/Utilities/ColorUtility'
import { BaseQuestion } from '@/components/Survey/QuestionTypes/BaseQuestion'
import {
  generateIndexSeries,
  generateSlicedSeries,
  getCategoriesForSlicedQuestion,
  getCategoriesForSlicedVariantQuestion,
  calcPercentage,
  getCategoriesWithExtremityLabels
} from '@/components/Survey/Utilities/ChartUtilities'
import Tabs from '@/components/Tabs/Tabs.vue'
import Tab from '@/components/Tabs/Tab.vue'
import OpenEndsCard from '@/components/Survey/TextResponses/OpenEndsCard.vue'
import {
  indexRateChartToolTipFormatter,
  slicedChartTooltipFormatter
} from '@/components/Survey/Utilities/ChartTooltipUtilities'
import SliceNotSupported from '@/components/Survey/SliceNotSupported.vue'

@Component({
  components: {
    Highcharts: Chart,
    Tabs,
    Tab,
    OpenEndsCard,
    SliceNotSupported
  }
})
export default class RateQuestion extends BaseQuestion {
  get responseTotals () {
    return this.rateScaleCategories.map((category, index) => {
      return {
        name: this.rateDisplayCategories[index],
        y: calcPercentage(this.indexTotals[category], this.indexResponses.length)
      }
    })
  }

  get indexSeries () {
    const data = this.responseTotals.map((category, index) => {
      return {
        ...category,
        color: this.rankedColors[index]
      }
    })

    return generateIndexSeries(data)
  }

  get series () {
    if (this.isSliced || this.isVariant) {
      return this.getSlicedSeries()
    } else {
      return this.indexSeries
    }
  }

  getSlicedSeries () {
    const slicedData = generateSlicedSeries(this.segmentTotals, this.rankedColors, this.rateScaleCategories)

    // Set the display categories for sliced data, as they don't have labels at this point
    slicedData.forEach((dataSet, index) => {
      dataSet.name = this.rateDisplayCategories[index]
      dataSet.data = dataSet.data.slice().reverse()
    })
    return slicedData
  }

  get scaleSize () {
    let maxRating = 5
    let minRating = 0

    if (typeof this.question.scaleProperties!.maxRating === 'number') {
      maxRating = this.question.scaleProperties!.maxRating
    }
    if (typeof this.question.scaleProperties!.minRating === 'number') {
      minRating = this.question.scaleProperties!.minRating
    }

    return (maxRating - minRating) + 1
  }

  get rankedColors () {
    return ColorUtils.generateDivergingColors(this.rateScaleCategories.length, this.colorConfiguration.divergentPalette).slice().reverse()
  }

  get chartOptions () {
    return {
      ...this.defaultChartOptions(),
      legend: {
        reversed: true
      },
      xAxis: {
        ...this.defaultChartOptions().xAxis,
        categories: this.categories,
        reversed: true
      },
      series: this.series,
      tooltip: this.isSliced || this.isVariant
        ? slicedChartTooltipFormatter(this.segmentTotals, this.question.type, this.sliceByQuestion?.type)
        : indexRateChartToolTipFormatter(this.indexTotals)
    }
  }

  get categories () {
    if (this.isSliced && this.isVariant) {
      return getCategoriesForSlicedVariantQuestion(this.typedSlicedVariantResponses, this.selectedTab).slice().reverse()
    } else if (this.isSliced || this.isVariant) {
      return getCategoriesForSlicedQuestion(this.segmentTotals, this.sliceByQuestion).slice().reverse()
    } else {
      return this.rateDisplayCategories
    }
  }

  get rateDisplayCategories () {
    return getCategoriesWithExtremityLabels(this.rateScaleCategories, this.question.scaleProperties!)
  }

  get rateScaleCategories () {
    const categories = []
    const startIndex = this.question.scaleProperties!.minRating ?? 0
    for (let i = startIndex; categories.length !== this.scaleSize; i++) {
      categories.push(i.toString())
    }
    return categories
  }
}
